import './bootstrap';

// Externals
import '@wwdev/bootstrap/index.js';
import '@wwdev/functions/index.js';
import './wwdev/forms/index';
import './wwdev/cookiebar/index';
import '@fancyapps/fancybox';
import './wwdev/lazysizes/index.js';
import './wwdev/webshop/index.js';
import '@wwdev/myaccount/index.js';
import '@wwdev/register';
import '@wwdev/search';
import '@wwdev/functions/setEqualHeightsPerRow';
import './externals/hamburgers.js';

import './base/PageScroll.js';
import './base/Animation.js';
import Animate from './base/Animate.js';
new Animate();
import './vendor/Contentlist/tags';

import './vendor/Shared/Header.js';
import './vendor/Shared/NavLinkToggle.js';

import './vendor/Search/SearchTab.js';
